/**
 * 对服务器中进行的处理
 * nuxt.config.js 的serverMiddleware 中使用该中间件
 * @param {*} req
 * @param {*} res
 * @param {*} next
 */

export default function (req, res, next) {
  // 因为 服务Nginx 会通过设置 proxy_cache proxy_cache_one 把html 缓存了，但入口还需要判断是否跳转移动端（mlearning）
  // 移动端的判断是通过http header 中的 via accept x-wap-profile profile user-agent 进行判断
  // 所以加入vary头，防止header变更读取缓存影响逻辑
  res.setHeader('vary', 'user-agent, via, accept, x-wap-profile, profile');
  next();
}
